const TENANT_ID = 'currentTenant';

export function getTenantFromLocalStorage() {
  return localStorage.getItem(TENANT_ID);
}

export function saveTenantLocalStorage(tenantId) {
  return localStorage.setItem(TENANT_ID, tenantId);
}

export function removeTenantFromLocalStorage() {
  localStorage.setItem(TENANT_ID, null);
}
